import { render, staticRenderFns } from "./LawyersReport.vue?vue&type=template&id=fe3ec7ba&lang=pug"
import script from "./LawyersReport.vue?vue&type=script&lang=js"
export * from "./LawyersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports